import type { IconNode } from '../types';

/**
 * @name palmtree-island-sun
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI2IiBjeT0iNyIgcj0iMyIgLz4KICA8cGF0aCBkPSJNMTYgMTRzMS0zIDEtOFY0cy0xLTItMy0yYy0xIDAtMiAuNS0yIC41IiAvPgogIDxwYXRoIGQ9Ik0xMyA4YTQgNCAwIDAgMSA4IDAiIC8+CiAgPHBhdGggZD0iTTE3IDRzMS0yIDMtMmMxIDAgMiAuNSAyIC41IiAvPgogIDxwYXRoIGQ9Ik0xOS43NSAxOUE4IDggMCAwIDAgNCAyMSIgLz4KICA8cGF0aCBkPSJNMiAyMGMuNi41IDEuMiAxIDIuNSAxIDIuNSAwIDIuNS0yIDUtMiAyLjYgMCAyLjQgMiA1IDIgMi41IDAgMi41LTIgNS0yIDEuMyAwIDEuOS41IDIuNSAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/palmtree-island-sun
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const palmtreeIslandSun: IconNode = [
  ['circle', { cx: '6', cy: '7', r: '3', key: 'y75ew0' }],
  ['path', { d: 'M16 14s1-3 1-8V4s-1-2-3-2c-1 0-2 .5-2 .5', key: '1kv3wi' }],
  ['path', { d: 'M13 8a4 4 0 0 1 8 0', key: 'lrfcfp' }],
  ['path', { d: 'M17 4s1-2 3-2c1 0 2 .5 2 .5', key: '8sabee' }],
  ['path', { d: 'M19.75 19A8 8 0 0 0 4 21', key: '1ax8zw' }],
  [
    'path',
    {
      d: 'M2 20c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1',
      key: '17ivm9',
    },
  ],
];

export default palmtreeIslandSun;
